// Form Templates Library - JSON-driven form configurations
// Updated by Claude for removing redundant validateForm actions on 2025-11-09 22:01:00
// Reason: Validation is already handled automatically in UniversalFormPreview.jsx before actions execute
export const FORM_TEMPLATES = {
  enrollment: {
    type: "Form",
    formType: "Enrollment",
    title: "Enrollment Form",
    description: "Complete your enrollment by filling out the required information",
    submitLabel: "Submit Enrollment",
    actions: [
      {
        action: "saveToTable",
        target: "enrollments",
        includeTimestamp: true,
        includeUserId: true
      },
      {
        action: "showMessage",
        message: "Thank you {{name}}! Your enrollment has been submitted successfully.",
        type: "success",
        duration: 5
      },
      {
        action: "sendEmail",
        to: "{{email}}",
        subject: "Enrollment Confirmation",
        body: "Dear {{name}},\n\nThank you for your enrollment. We have received your application and will process it shortly.\n\nBest regards,\nThe Team",
        isHtml: false,
        includeFormData: true
      }
    ],
    fields: [
      {
        id: "name",
        label: "Full Name",
        smartFieldType: "mudumbai_textOnly",
        type: "text",
        required: true,
        validation: {
          pattern: "^[a-zA-Z\\s'-]+$",
          trim: true,
          minLength: 2,
          maxLength: 100
        },
        errorMessages: {
          pattern: "Only letters, spaces, hyphens and apostrophes are allowed",
          minLength: "Must be at least 2 characters",
          maxLength: "Cannot exceed 100 characters",
          required: "This field is required"
        },
        placeholder: "Enter text here",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textOnly",
          version: "1.0.0"
        }
      },
      {
        id: "email",
        label: "Email Address",
        smartFieldType: "mudumbai_emailOnly",
        type: "email",
        required: true,
        validation: {
          pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
          maxLength: 254,
          trim: true,
          toLowerCase: true
        },
        errorMessages: {
          pattern: "Please enter a valid email address (e.g., name@example.com)",
          maxLength: "Email address is too long",
          required: "Email address is required"
        },
        placeholder: "name@example.com",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_emailOnly",
          version: "1.0.0"
        }
      },
      {
        id: "phone",
        label: "Phone Number",
        smartFieldType: "mudumbai_phoneOnly",
        type: "tel",
        required: true,
        validation: {
          pattern: "^[0-9]{10}$",
          length: 10,
          trim: true
        },
        errorMessages: {
          pattern: "Phone number must be exactly 10 digits",
          length: "Phone number must be 10 digits",
          required: "Phone number is required"
        },
        placeholder: "9876543210",
        formatting: {
          mask: "9999999999",
          stripNonNumeric: true
        },
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_phoneOnly",
          version: "1.0.0"
        }
      },
      {
        id: "class",
        label: "Class",
        smartFieldType: "mudumbai_dropdown",
        type: "dropdown",
        required: true,
        validation: {},
        errorMessages: {
          required: "Please select an option"
        },
        dataSource: {
          type: "manual",
          options: ["1st Grade", "2nd Grade", "3rd Grade", "4th Grade", "5th Grade", "6th Grade", "7th Grade", "8th Grade", "9th Grade", "10th Grade", "11th Grade", "12th Grade"]
        },
        placeholder: "Select option",
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_dropdown",
          version: "1.0.0"
        }
      },
      {
        id: "guardianName",
        label: "Guardian Name",
        smartFieldType: "mudumbai_textOnly",
        type: "text",
        required: true,
        validation: {
          pattern: "^[a-zA-Z\\s'-]+$",
          trim: true,
          minLength: 2,
          maxLength: 100
        },
        errorMessages: {
          pattern: "Only letters, spaces, hyphens and apostrophes are allowed",
          minLength: "Must be at least 2 characters",
          maxLength: "Cannot exceed 100 characters",
          required: "This field is required"
        },
        placeholder: "Enter text here",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textOnly",
          version: "1.0.0"
        }
      }
    ],
    metadata: {
      createdAt: "2025-11-09T00:00:00.000Z",
      validationVersion: "1.0.0",
      tags: ["enrollment", "education", "registration"],
      layout: "single-column"
    }
  },

  signup: {
    type: "Form",
    formType: "Signup",
    title: "Create Account",
    description: "Sign up to get started with your new account",
    submitLabel: "Create Account",
    actions: [
      {
        action: "saveToTable",
        target: "users",
        includeTimestamp: true
      },
      {
        action: "showMessage",
        message: "Welcome {{name}}! Your account has been created successfully.",
        type: "success",
        duration: 5
      },
      {
        action: "navigate",
        route: "/welcome",
        delay: 2
      }
    ],
    fields: [
      {
        id: "name",
        label: "Full Name",
        smartFieldType: "mudumbai_textOnly",
        type: "text",
        required: true,
        validation: {
          pattern: "^[a-zA-Z\\s'-]+$",
          trim: true,
          minLength: 2,
          maxLength: 100
        },
        errorMessages: {
          pattern: "Only letters, spaces, hyphens and apostrophes are allowed",
          minLength: "Must be at least 2 characters",
          maxLength: "Cannot exceed 100 characters",
          required: "This field is required"
        },
        placeholder: "Enter text here",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textOnly",
          version: "1.0.0"
        }
      },
      {
        id: "email",
        label: "Email Address",
        smartFieldType: "mudumbai_emailOnly",
        type: "email",
        required: true,
        validation: {
          pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
          maxLength: 254,
          trim: true,
          toLowerCase: true
        },
        errorMessages: {
          pattern: "Please enter a valid email address (e.g., name@example.com)",
          maxLength: "Email address is too long",
          required: "Email address is required"
        },
        placeholder: "name@example.com",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_emailOnly",
          version: "1.0.0"
        }
      },
      {
        id: "password",
        label: "Password",
        smartFieldType: "mudumbai_passwordOnly",
        type: "password",
        required: true,
        validation: {
          minLength: 8,
          pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d@$!%*?&]{8,}$"
        },
        errorMessages: {
          pattern: "Password must contain uppercase, lowercase and at least one number",
          minLength: "Password must be at least 8 characters long",
          required: "Password is required"
        },
        placeholder: "Enter password",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_passwordOnly",
          version: "1.0.0"
        }
      },
      {
        id: "confirmPassword",
        label: "Confirm Password",
        smartFieldType: "mudumbai_passwordOnly",
        type: "password",
        required: true,
        validation: {
          minLength: 8,
          pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d@$!%*?&]{8,}$"
        },
        errorMessages: {
          pattern: "Password must contain uppercase, lowercase and at least one number",
          minLength: "Password must be at least 8 characters long",
          required: "Password is required"
        },
        placeholder: "Confirm your password",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_passwordOnly",
          version: "1.0.0"
        }
      }
    ],
    metadata: {
      createdAt: "2025-11-09T00:00:00.000Z",
      validationVersion: "1.0.0",
      tags: ["signup", "registration", "account"],
      layout: "single-column"
    }
  },

  signin: {
    type: "Form",
    formType: "Signin",
    title: "Sign In",
    description: "Welcome back! Please sign in to your account",
    submitLabel: "Sign In",
    actions: [
      {
        action: "showMessage",
        message: "Welcome back!",
        type: "success",
        duration: 3
      }
    ],
    fields: [
      {
        id: "email",
        label: "Email Address",
        smartFieldType: "mudumbai_emailOnly",
        type: "email",
        required: true,
        validation: {
          pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
          maxLength: 254,
          trim: true,
          toLowerCase: true
        },
        errorMessages: {
          pattern: "Please enter a valid email address (e.g., name@example.com)",
          maxLength: "Email address is too long",
          required: "Email address is required"
        },
        placeholder: "name@example.com",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_emailOnly",
          version: "1.0.0"
        }
      },
      {
        id: "password",
        label: "Password",
        smartFieldType: "mudumbai_passwordOnly",
        type: "password",
        required: true,
        validation: {
          minLength: 1
        },
        errorMessages: {
          minLength: "Please enter your password",
          required: "Password is required"
        },
        placeholder: "Enter your password",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_passwordOnly",
          version: "1.0.0"
        }
      }
    ],
    metadata: {
      createdAt: "2025-11-09T00:00:00.000Z",
      validationVersion: "1.0.0",
      tags: ["signin", "login", "authentication"],
      layout: "single-column"
    }
  },
  contact: {
    type: "Form",
    formType: "Contact",
    title: "Contact Us",
    description: "Get in touch with us. We'd love to hear from you!",
    submitLabel: "Send Message",
    actions: [
      {
        action: "saveToTable",
        target: "contacts",
        includeTimestamp: true
      },
      {
        action: "showMessage",
        message: "Thank you {{name}}! We received your message and will get back to you soon.",
        type: "success",
        duration: 5
      }
    ],
    fields: [
      {
        id: "name",
        label: "Your Name",
        smartFieldType: "mudumbai_textOnly",
        type: "text",
        required: true,
        validation: {
          pattern: "^[a-zA-Z\\s'-]+$",
          trim: true,
          minLength: 2,
          maxLength: 100
        },
        errorMessages: {
          pattern: "Only letters, spaces, hyphens and apostrophes are allowed",
          minLength: "Must be at least 2 characters",
          maxLength: "Cannot exceed 100 characters",
          required: "This field is required"
        },
        placeholder: "Enter text here",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        advancedOptions: {
          visibleOnlyWhen: null,
          captureOnlyWhen: null,
          makeReadOnlyWhen: null,
          additionalValidations: []
        },
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textOnly",
          version: "1.0.0"
        }
      },
      {
        id: "email",
        label: "Email Address",
        smartFieldType: "mudumbai_emailOnly",
        type: "email",
        required: true,
        validation: {
          pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
          maxLength: 254,
          trim: true,
          toLowerCase: true
        },
        errorMessages: {
          pattern: "Please enter a valid email address (e.g., name@example.com)",
          maxLength: "Email address is too long",
          required: "Email address is required"
        },
        placeholder: "name@example.com",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        advancedOptions: {
          visibleOnlyWhen: null,
          captureOnlyWhen: null,
          makeReadOnlyWhen: null,
          additionalValidations: []
        },
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_emailOnly",
          version: "1.0.0"
        }
      },
      {
        id: "phone",
        label: "Phone Number",
        smartFieldType: "mudumbai_phoneOnly",
        type: "tel",
        required: false,
        validation: {
          pattern: "^[0-9]{10}$",
          length: 10,
          trim: true
        },
        errorMessages: {
          pattern: "Phone number must be exactly 10 digits",
          length: "Phone number must be 10 digits",
          required: "Phone number is required"
        },
        placeholder: "9876543210",
        formatting: {
          mask: "9999999999",
          stripNonNumeric: true
        },
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        advancedOptions: {
          visibleOnlyWhen: null,
          captureOnlyWhen: null,
          makeReadOnlyWhen: null,
          additionalValidations: []
        },
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_phoneOnly",
          version: "1.0.0"
        }
      },
      {
        id: "subject",
        label: "Subject",
        smartFieldType: "mudumbai_textOnly",
        type: "text",
        required: true,
        validation: {
          pattern: "^[a-zA-Z\\s'-]+$",
          trim: true,
          minLength: 2,
          maxLength: 100
        },
        errorMessages: {
          pattern: "Only letters, spaces, hyphens and apostrophes are allowed",
          minLength: "Must be at least 2 characters",
          maxLength: "Cannot exceed 100 characters",
          required: "This field is required"
        },
        placeholder: "Enter text here",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        advancedOptions: {
          visibleOnlyWhen: null,
          captureOnlyWhen: null,
          makeReadOnlyWhen: null,
          additionalValidations: []
        },
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textOnly",
          version: "1.0.0"
        }
      },
      {
        id: "message",
        label: "Message",
        smartFieldType: "mudumbai_textMultiline",
        type: "textarea",
        required: true,
        validation: {
          minLength: 10,
          maxLength: 1000,
          trim: true
        },
        errorMessages: {
          minLength: "Text must be at least 10 characters",
          maxLength: "Text cannot exceed 1000 characters",
          required: "This field is required"
        },
        placeholder: "Enter your text here...",
        rows: 4,
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        advancedOptions: {
          visibleOnlyWhen: null,
          captureOnlyWhen: null,
          makeReadOnlyWhen: null,
          additionalValidations: []
        },
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textMultiline",
          version: "1.0.0"
        }
      },
      {
        id: "companyName",
        label: "Company Name",
        smartFieldType: "mudumbai_textOnly",
        type: "text",
        required: false,
        validation: {
          pattern: "^[a-zA-Z\\s'-]+$",
          trim: true,
          minLength: 2,
          maxLength: 100
        },
        errorMessages: {
          pattern: "Only letters, spaces, hyphens and apostrophes are allowed",
          minLength: "Must be at least 2 characters",
          maxLength: "Cannot exceed 100 characters",
          required: "This field is required"
        },
        placeholder: "Enter text here",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        advancedOptions: {
          visibleOnlyWhen: null,
          captureOnlyWhen: null,
          makeReadOnlyWhen: null,
          additionalValidations: []
        },
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textOnly",
          version: "1.0.0"
        }
      },
      {
        id: "preferredContactMethod",
        label: "Preferred Contact Method",
        smartFieldType: "mudumbai_dropdown",
        type: "dropdown",
        required: false,
        validation: {},
        errorMessages: {
          required: "Please select an option"
        },
        dataSource: {
          type: "manual",
          options: ["Email", "Phone", "Either"]
        },
        placeholder: "Select option",
        visibility: true,
        defaultValue: "",
        advancedOptions: {
          visibleOnlyWhen: null,
          captureOnlyWhen: null,
          makeReadOnlyWhen: null,
          additionalValidations: []
        },
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_dropdown",
          version: "1.0.0"
        }
      }
    ],
    metadata: {
      createdAt: "2025-11-01T00:00:00.000Z",
      validationVersion: "1.0.0",
      tags: ["contact", "communication", "support"],
      layout: "single-column"
    }
  },


  feedback: {
    type: "Form",
    formType: "Feedback",
    title: "Feedback Form",
    description: "Help us improve by sharing your feedback",
    submitLabel: "Submit Feedback",
    actions: [
      {
        action: "saveToTable",
        target: "feedback",
        includeTimestamp: true
      },
      {
        action: "showMessage",
        message: "Thank you {{name}}! Your feedback has been submitted.",
        type: "success",
        duration: 5
      }
    ],
    fields: [
      {
        id: "name",
        label: "Your Name",
        smartFieldType: "mudumbai_textOnly",
        type: "text",
        required: true,
        validation: {
          pattern: "^[a-zA-Z\\s'-]+$",
          trim: true,
          minLength: 2,
          maxLength: 100
        },
        errorMessages: {
          pattern: "Only letters, spaces, hyphens and apostrophes are allowed",
          minLength: "Must be at least 2 characters",
          maxLength: "Cannot exceed 100 characters",
          required: "This field is required"
        },
        placeholder: "Enter text here",
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textOnly",
          version: "1.0.0"
        }
      },
      {
        id: "rating",
        label: "Rating",
        smartFieldType: "mudumbai_dropdown",
        type: "dropdown",
        required: true,
        validation: {},
        errorMessages: {
          required: "Please select an option"
        },
        dataSource: {
          type: "manual",
          options: ["5 - Excellent", "4 - Good", "3 - Average", "2 - Poor", "1 - Very Poor"]
        },
        placeholder: "Select option",
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_dropdown",
          version: "1.0.0"
        }
      },
      {
        id: "comments",
        label: "Comments",
        smartFieldType: "mudumbai_textMultiline",
        type: "textarea",
        required: false,
        validation: {
          minLength: 10,
          maxLength: 500,
          trim: true
        },
        errorMessages: {
          minLength: "Text must be at least 10 characters",
          maxLength: "Text cannot exceed 500 characters",
          required: "This field is required"
        },
        placeholder: "Enter your feedback here...",
        rows: 4,
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textMultiline",
          version: "1.0.0"
        }
      }
    ],
    metadata: {
      createdAt: "2025-11-09T00:00:00.000Z",
      validationVersion: "1.0.0",
      tags: ["feedback", "review", "rating"],
      layout: "single-column"
    }
  },

  maintenance: {
    type: "Form",
    formType: "Maintenance",
    title: "Maintenance Request",
    description: "Submit a maintenance request for prompt assistance",
    submitLabel: "Submit Request",
    actions: [
      {
        action: "saveToTable",
        target: "maintenance_requests",
        includeTimestamp: true
      },
      {
        action: "showMessage",
        message: "Your maintenance request has been submitted. We'll respond shortly!",
        type: "success",
        duration: 5
      }
    ],
    fields: [
      {
        id: "requestType",
        label: "Request Type",
        smartFieldType: "mudumbai_dropdown",
        type: "dropdown",
        required: true,
        validation: {},
        errorMessages: {
          required: "Please select an option"
        },
        dataSource: {
          type: "manual",
          options: ["Electrical", "Plumbing", "Cleaning", "HVAC", "Carpentry", "Painting", "Other"]
        },
        placeholder: "Select option",
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_dropdown",
          version: "1.0.0"
        }
      },
      {
        id: "description",
        label: "Description",
        smartFieldType: "mudumbai_textMultiline",
        type: "textarea",
        required: true,
        validation: {
          minLength: 10,
          maxLength: 1000,
          trim: true
        },
        errorMessages: {
          minLength: "Text must be at least 10 characters",
          maxLength: "Text cannot exceed 1000 characters",
          required: "This field is required"
        },
        placeholder: "Enter your text here...",
        rows: 4,
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_textMultiline",
          version: "1.0.0"
        }
      },
      {
        id: "priority",
        label: "Priority Level",
        smartFieldType: "mudumbai_dropdown",
        type: "dropdown",
        required: true,
        validation: {},
        errorMessages: {
          required: "Please select an option"
        },
        dataSource: {
          type: "manual",
          options: ["High - Urgent", "Medium - Normal", "Low - When Convenient"]
        },
        placeholder: "Select option",
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_dropdown",
          version: "1.0.0"
        }
      },
      {
        id: "photo",
        label: "Upload Photo",
        smartFieldType: "mudumbai_file",
        type: "file",
        required: false,
        validation: {
          maxSize: 5242880,
          allowedTypes: []
        },
        errorMessages: {
          maxSize: "File size must be less than 5MB",
          allowedTypes: "File type not allowed",
          required: "Please upload a file"
        },
        dataSource: { type: "manual" },
        visibility: true,
        defaultValue: "",
        _validationRef: {
          source: "field-validations",
          key: "mudumbai_file",
          version: "1.0.0"
        }
      }
    ],
    metadata: {
      createdAt: "2025-11-09T00:00:00.000Z",
      validationVersion: "1.0.0",
      tags: ["maintenance", "support", "request"],
      layout: "single-column"
    }
  },

  custom: {
    type: "Form",
    formType: "Custom",
    title: "Custom Form",
    description: "Create your custom form by adding fields below",
    submitLabel: "Submit",
    actions: [],
    fields: []
  }
};

// Helper function to get form template by type
export const getFormTemplate = (formType) => {
  const template = FORM_TEMPLATES[formType.toLowerCase()];
  if (!template) {
    throw new Error(`Form template not found: ${formType}`);
  }
  
  // Return a deep copy to avoid mutations
  return JSON.parse(JSON.stringify(template));
};

// Get all available form types
export const getFormTypes = () => {
  return [
    { value: 'enrollment', label: 'Enrollment' },
    { value: 'signup', label: 'Signup' },
    { value: 'signin', label: 'Signin' },
    { value: 'contact', label: 'Contact' },
    { value: 'feedback', label: 'Feedback' },
    { value: 'maintenance', label: 'Maintenance Request' },
    { value: 'custom', label: 'Custom' }
  ];
};

// Field type options for the form builder
export const FIELD_TYPES = [
  { value: 'text', label: 'Text' },
  { value: 'email', label: 'Email' },
  { value: 'password', label: 'Password' },
  { value: 'tel', label: 'Phone' },
  { value: 'number', label: 'Number' },
  { value: 'textarea', label: 'Textarea' },
  { value: 'date', label: 'Date' },
  { value: 'datetime-local', label: 'Date & Time' },
  { value: 'checkbox', label: 'Checkbox' },
  { value: 'radio', label: 'Radio Group' },
  { value: 'dropdown', label: 'Dropdown' },
  { value: 'file', label: 'File Upload' },
  { value: 'hidden', label: 'Hidden' }
];

// Data source types
export const DATA_SOURCE_TYPES = [
  { value: 'manual', label: 'Manual List' },
  { value: 'api', label: 'From API' },
  { value: 'state', label: 'From State' }
];
